import { Flex } from '@chakra-ui/react';

interface NavigationItemBadgeProps {
  count: number;
}

export function NavigationItemBadge({ count }: NavigationItemBadgeProps) {
  if (count === 0) return null;

  return (
    <Flex
      position="absolute"
      right={0}
      top={0}
      alignItems="center"
      justifyContent="center"
      boxSize={4}
      bg="texas.burntSienna.500"
      color="white"
      fontSize="10px"
      fontWeight="bold"
      pointerEvents="none"
    >
      {count > 9 ? '9+' : count}
    </Flex>
  );
}
